import { isUrlPatternMatching } from '../../../util/string.helpers'
import { MODA_REDEMPTION_URL_MATCH_ORDER } from '../constants/app'

const NON_PRIORITY_INDEX = Number.MAX_SAFE_INTEGER

const redemptionPriorityIndex = (redeemOption) => {
  const website = redeemOption?.website
  if (!website) {
    return NON_PRIORITY_INDEX
  }

  const priorityIndex = MODA_REDEMPTION_URL_MATCH_ORDER.findIndex(
    (urlPattern) => {
      return isUrlPatternMatching(website, urlPattern)
    }
  )

  return priorityIndex === -1 ? NON_PRIORITY_INDEX : priorityIndex
}

const orderRedeemOptions = (redeemOptions) => {
  if (!redeemOptions?.length) {
    return []
  }

  return redeemOptions
    .map((redeemOption, index) => ({
      redeemOption,
      index,
      priority: redemptionPriorityIndex(redeemOption)
    }))
    .sort((left, right) => {
      return left.priority - right.priority || left.index - right.index
    })
    .map(({ redeemOption }) => redeemOption)
}

export default orderRedeemOptions
